exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-turnover-report-table[data-v-72b573b3],.customer-turnover-report-table>*[data-v-72b573b3]{width:100%}", ""]);

// exports
